const n = Symbol("language resolver updated");
class l {
  constructor(t) {
    this.language = document.documentElement.lang || navigator.language, this.host = t, this.host.addController(this);
  }
  hostConnected() {
    this.resolveLanguage();
  }
  hostDisconnected() {
    var t;
    (t = this.unsubscribe) == null || t.call(this);
  }
  resolveLanguage() {
    const t = new CustomEvent("sp-language-context", { bubbles: !0, composed: !0, detail: { callback: (s, e) => {
      const a = this.language;
      this.language = s, this.unsubscribe = e, this.host.requestUpdate(n, a);
    } }, cancelable: !0 });
    this.host.dispatchEvent(t);
  }
}
export {
  l as L,
  n as l
};
//# sourceMappingURL=LanguageResolution-DZo7k7_g.js.map
